/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConnectivityEvent { 
    source: string | null;
    timestamp: string;
    deviceTwistId?: string | null;
    modelIndex?: number | null;
    summary?: string | null;
    deviceName?: string | null;
    modelTypeName?: string | null;
    transition?: string | null;
    reason?: string | null;
    type: ConnectivityEventTypeEnum;
}
export enum ConnectivityEventTypeEnum {
    Connectivity = 'connectivity'
};



